import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Zap } from "react-feather";

const OtpModal = ({ email, onClose }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  // Handle input change
  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1); // Only allow one digit per input
    setOtp(newOtp);

    // Auto-focus on the next input field
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  // Handle keydown for backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        document.getElementById(`otp-${index - 1}`).focus(); // Focus previous input
      }
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <motion.div
        className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header Animation */}
        <motion.div
          className="flex flex-col items-center space-y-2 mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Link to="/" className="flex flex-row items-center space-x-2">
            <Zap className="w-8 h-8 text-blue-500" />
            <span className="text-xl md:text-3xl font-bold text-gray-900">
              Resume Advisor
            </span>
          </Link>
        </motion.div>

        {/* Text */}
        <motion.h2
          className="text-xl font-bold text-gray-800 text-center mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          OTP Verification
        </motion.h2>
        <motion.p
          className="text-sm text-gray-600 text-center mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          Verify your account with the email: <strong>{email}</strong>
        </motion.p>

        {/* OTP Input Fields */}
        <motion.div
          className="flex justify-center space-x-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              type="text"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-12 h-12 border rounded-md text-center text-lg font-bold focus:outline-none focus:ring focus:ring-blue-300"
              maxLength={1}
            />
          ))}
        </motion.div>

        {/* Resend and Verify Button */}
        <motion.div
          className="text-center mt-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
        >
          <p className="text-sm text-gray-500">
            Didn’t receive the OTP code?{" "}
            <button className="text-blue-600 hover:underline">
              Resend Code
            </button>
          </p>
          <button
            className="w-full bg-blue-600 text-white py-2 rounded-md mt-4 hover:bg-blue-500 transition"
            onClick={() => alert("OTP Verified!")}
          >
            Verify & Proceed
          </button>
        </motion.div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
      </motion.div>
    </div>
  );
};

export default OtpModal;
